import ReactDOM from 'react-dom/client';
import React from 'react';
import { TenantContext } from '../../../context/tenant-context';
import { v2Component } from '../../../index';
import { SelectPayment } from './select-payment';

export function initSelectPaymentComponent() {
  document.getElementsByName('select-payment-component').forEach((element) => {
    if (element.getAttribute('initialized') !== 'true') {
      element.setAttribute('initialized', 'true');
      const root = ReactDOM.createRoot(element);
      const setRootAttributes = (o: any) => {
        Object.keys(o).forEach((k) => {
          element.setAttribute(k, o[k]);
        });
      };

      const bootstrap = (mutations: MutationRecord[]) => {
        if (mutations.length === 0 || mutations.find((r) => r.attributeName === 'data-amount')) {
          const { tenant, contextPath, ...rest } = Object.assign({}, element.dataset) as any;
          const props = {
            ...rest,
            amount: parseFloat(rest.amount),
            mode: 'setup',
          };
          root.render(
            v2Component(
              <TenantContext.Provider value={{ tenant, contextPath, spaMode: false }}>
                <SelectPayment {...props} setRootAttributes={setRootAttributes} />
              </TenantContext.Provider>,
            ),
          );

          const event = new CustomEvent('change');
          element.dispatchEvent(event);
        }
      };
      const observer = new MutationObserver(bootstrap);
      observer.observe(element, { attributes: true });
      bootstrap([]);
    }
  });
}
